var _g, _g2, _g3, _g4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMobileWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 158,
    height: 102,
    viewBox: "0 0 158 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_3095_24513)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3095_24513)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.1963,
    y: 7,
    width: 94.036,
    height: 60.9746,
    rx: 4.44306,
    fill: "#CACCD8",
    fillOpacity: 0.2,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dd_3095_24513)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.88611,
    height: 76.365,
    transform: "translate(31.1963 7)",
    fill: "#CACCD8",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3095_24513)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.6394 11.7207C36.2153 11.7207 36.7247 11.7675 37.0346 11.8392C37.6525 11.9693 38.1391 12.4572 38.2688 13.0769C38.3403 13.3877 38.3869 13.8986 38.3869 14.4761C38.3869 15.0536 38.3403 15.5645 38.2688 15.8753C38.1391 16.495 37.6525 16.9829 37.0346 17.113C36.7247 17.1847 36.2153 17.2315 35.6394 17.2315C35.0635 17.2315 34.5541 17.1847 34.2442 17.113C33.6263 16.9829 33.1397 16.495 33.01 15.8753C32.9385 15.5645 32.8918 15.0536 32.8918 14.4761C32.8918 13.8986 32.9385 13.3877 33.01 13.0769C33.1397 12.4572 33.6263 11.9693 34.2442 11.8392C34.5541 11.7675 35.0635 11.7207 35.6394 11.7207ZM36.0021 15.7043C36.1368 15.7327 36.2474 15.8264 36.2996 15.9509C36.3168 15.9919 36.3586 16.0171 36.403 16.013C36.4162 16.0118 36.4275 16.0107 36.4368 16.0098C36.652 15.9883 36.8212 15.9583 36.9195 15.9233L36.9201 15.9231C36.9861 15.8982 37.0331 15.8343 37.0331 15.7593C37.0331 15.7575 37.0331 15.7556 37.033 15.7538L37.0325 15.7445L37.0323 15.7424C37.0321 15.7405 37.032 15.7386 37.0319 15.7368C37.0152 15.5119 36.879 14.9853 36.6756 14.3844C36.443 13.6974 36.1998 13.1412 36.0901 13.0327C36.0728 13.0146 36.0524 12.9991 36.0301 12.9873C36.0214 12.9823 36.0104 12.9776 35.9973 12.973L35.9961 12.9727C35.9242 12.9483 35.7914 12.9319 35.6392 12.9319C35.4873 12.9319 35.3545 12.9483 35.2824 12.9727L35.2814 12.973C35.2683 12.9776 35.2573 12.9823 35.2485 12.9873C35.2262 12.9991 35.206 13.0144 35.1885 13.0327C35.0789 13.1412 34.8357 13.6974 34.6031 14.3844C34.3997 14.9853 34.2635 15.5119 34.2467 15.7368C34.2467 15.7386 34.2466 15.7405 34.2464 15.7424L34.2462 15.7445L34.2457 15.7538C34.2456 15.7547 34.2456 15.7557 34.2456 15.7566C34.2456 15.7575 34.2456 15.7584 34.2456 15.7593C34.2456 15.8343 34.2926 15.8982 34.3586 15.9231L34.3592 15.9233C34.4576 15.9583 34.6269 15.9884 34.8424 16.0099C34.8507 16.0107 34.8606 16.0116 34.872 16.0127C34.9183 16.017 34.962 15.9909 34.9802 15.9482C35.0328 15.8251 35.1429 15.7325 35.2766 15.7043C35.3572 15.6857 35.4896 15.6735 35.6393 15.6735C35.7891 15.6735 35.9215 15.6857 36.0021 15.7043Z",
    fill: "#F7F8FC"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 33.4177,
    y: 21.9521,
    width: 4.44306,
    height: 4.44306,
    rx: 0.90273,
    fill: "#F7F8FC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.4177,
    y: 29.7275,
    width: 4.44306,
    height: 4.44306,
    rx: 0.90273,
    fill: "#F7F8FC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.4177,
    y: 37.5029,
    width: 4.44306,
    height: 4.44306,
    rx: 0.90273,
    fill: "#F7F8FC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.4177,
    y: 45.2783,
    width: 4.44306,
    height: 4.44306,
    rx: 0.90273,
    fill: "#F7F8FC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.4177,
    y: 53.0537,
    width: 4.44306,
    height: 4.44306,
    rx: 0.90273,
    fill: "#F7F8FC"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_3095_24513)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 85.1498,
    height: 19.9553,
    transform: "translate(40.0825 7)",
    fill: "#CACCD8",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.1777,
    y: 14.0952,
    width: 13.3036,
    height: 2.66071,
    rx: 1.33036,
    fill: "#F7F8FC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.1777,
    y: 18.5298,
    width: 17.7381,
    height: 1.33036,
    rx: 0.665178,
    fill: "#F7F8FC"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 31.1409,
    y: 6.94457,
    width: 94.1468,
    height: 61.0855,
    rx: 4.49849,
    stroke: "#EAEBF0",
    strokeWidth: 0.110863,
    shapeRendering: "crispEdges"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_3095_24513)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.0757,
    y: 39.2822,
    width: 18.3654,
    height: 18.3654,
    rx: 9.1827,
    transform: "rotate(5 15.0757 39.2822)",
    fill: "url(#paint0_linear_3095_24513)",
    fillOpacity: 0.6,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.2019,
    y: 39.4326,
    width: 18.0877,
    height: 18.0877,
    rx: 9.04386,
    transform: "rotate(5 15.2019 39.4326)",
    stroke: "url(#paint1_linear_3095_24513)",
    strokeOpacity: 0.5,
    strokeWidth: 0.277691,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3985 52.1682C24.3228 51.9214 24.1335 51.724 23.8888 51.6479C23.7426 51.5991 23.4993 51.5544 23.2219 51.5301C22.9445 51.5058 22.6971 51.5077 22.5448 51.5303C22.2924 51.5625 22.073 51.722 21.9549 51.9493C21.914 52.0281 21.8286 52.071 21.7437 52.0553C21.7227 52.0514 21.7045 52.048 21.6893 52.0451C21.2937 51.969 20.985 51.884 20.8086 51.801C20.8083 51.8008 20.808 51.8006 20.8076 51.8004C20.6894 51.7421 20.6131 51.6121 20.6256 51.4686C20.6259 51.465 20.6263 51.4615 20.6267 51.4579C20.6275 51.4522 20.6283 51.4463 20.6292 51.4403C20.6295 51.439 20.6297 51.4377 20.6299 51.4364C20.6306 51.4326 20.6312 51.429 20.6316 51.4255C20.7003 50.9975 21.0408 50.0113 21.5183 48.8934C22.0642 47.6153 22.6079 46.5896 22.8293 46.3996C22.8647 46.3674 22.9047 46.3414 22.9481 46.3224C22.965 46.3143 22.9863 46.3069 23.0113 46.3004C23.012 46.3002 23.0126 46.3001 23.0133 46.2999C23.1509 46.2648 23.3996 46.255 23.681 46.2796C23.963 46.3042 24.2062 46.3571 24.3354 46.4155C24.3362 46.4159 24.3368 46.4161 24.3374 46.4164C24.361 46.4272 24.3806 46.4381 24.3959 46.4491C24.4353 46.4753 24.4702 46.5079 24.4993 46.5453C24.4994 46.5454 24.4994 46.5456 24.4995 46.5457C24.6845 46.7713 25.0418 47.8758 25.3575 49.2292C25.6336 50.4131 25.7977 51.4435 25.7911 51.8769C25.7909 51.8804 25.7908 51.8841 25.7908 51.8879C25.7908 51.8892 25.7908 51.8906 25.7908 51.8919C25.7907 51.898 25.7905 51.9039 25.7902 51.9097C25.79 51.9132 25.7898 51.9168 25.7895 51.9204C25.7769 52.0638 25.6792 52.1786 25.5527 52.2156C25.5522 52.2157 25.5519 52.2158 25.5515 52.216C25.3636 52.2671 25.0452 52.2971 24.6429 52.3034C24.6255 52.3037 24.6044 52.3039 24.5797 52.3041L24.5797 52.3041C24.4968 52.3047 24.4235 52.2497 24.3985 52.1682Z",
    fill: "#3086EE"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_3095_24513)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 120.941,
    y: 29.6572,
    width: 20.7489,
    height: 20.7489,
    rx: 10.3744,
    transform: "rotate(-15 120.941 29.6572)",
    fill: "url(#paint2_linear_3095_24513)",
    fillOpacity: 0.6,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.111,
    y: 29.7554,
    width: 20.4712,
    height: 20.4712,
    rx: 10.2356,
    transform: "rotate(-15 121.111 29.7554)",
    stroke: "url(#paint3_linear_3095_24513)",
    strokeOpacity: 0.5,
    strokeWidth: 0.277691,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.198 35.0793C136.874 35.152 135.631 34.4126 135.031 33.2078C135.004 33.1474 134.94 33.1191 134.868 33.1385C134.806 33.1552 134.765 33.2112 134.761 33.28C134.844 34.6237 134.127 35.8879 132.954 36.4845C132.895 36.5116 132.867 36.5754 132.887 36.6492C132.904 36.7123 132.96 36.7539 133.027 36.7583C134.352 36.6856 135.594 37.425 136.192 38.6193C136.219 38.6797 136.282 38.708 136.355 38.6886C136.417 38.6719 136.458 38.6159 136.462 38.5471C136.379 37.2034 137.098 35.9497 138.272 35.3532C138.331 35.326 138.358 35.2622 138.339 35.1885C138.319 35.1147 138.263 35.0731 138.198 35.0793Z",
    fill: "#3086EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.818 39.1684C133.756 39.2271 132.754 38.6377 132.27 37.6613C132.246 37.6114 132.196 37.5909 132.144 37.6048C132.092 37.6187 132.059 37.6614 132.063 37.7168C132.132 38.8044 131.559 39.8159 130.61 40.2958C130.561 40.3202 130.541 40.3707 130.555 40.4234C130.569 40.476 130.612 40.5098 130.666 40.5065C131.728 40.4477 132.73 41.0371 133.211 42.0031C133.236 42.053 133.286 42.0734 133.337 42.0596C133.389 42.0457 133.422 42.003 133.419 41.9475C133.352 40.8705 133.925 39.859 134.874 39.379C134.923 39.3546 134.943 39.3042 134.929 39.2515C134.915 39.1988 134.872 39.165 134.818 39.1684Z",
    fill: "#3086EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.596 37.7146C130.634 37.7722 130.697 37.8005 130.759 37.7838C130.821 37.7672 130.872 37.7084 130.865 37.6424C130.832 36.6468 131.378 35.6991 132.231 35.2336C132.287 35.1959 132.314 35.1321 132.297 35.0689C132.281 35.0057 132.222 34.9536 132.157 34.9597C131.162 34.978 130.239 34.4352 129.768 33.5457C129.74 33.4853 129.667 33.4598 129.605 33.4765C129.543 33.4931 129.492 33.5519 129.498 33.6179C129.524 34.6268 129.007 35.5556 128.136 36.0372C128.079 36.075 128.052 36.1387 128.069 36.2019C128.086 36.2651 128.144 36.3172 128.209 36.3111C129.181 36.2878 130.117 36.8384 130.596 37.7146Z",
    fill: "#3086EE"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_3095_24513)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 119.276,
    y: 63.54,
    width: 18.3654,
    height: 18.3654,
    rx: 9.1827,
    transform: "rotate(-5 119.276 63.54)",
    fill: "url(#paint4_linear_3095_24513)",
    fillOpacity: 0.6,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.426,
    y: 63.6663,
    width: 18.0877,
    height: 18.0877,
    rx: 9.04386,
    transform: "rotate(-5 119.426 63.6663)",
    stroke: "url(#paint5_linear_3095_24513)",
    strokeOpacity: 0.5,
    strokeWidth: 0.277691,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_3095_24513)"
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 125.614,
    y: 68.8584,
    width: 6.66458,
    height: 6.66458,
    rx: 1.11076,
    transform: "rotate(-5 125.614 68.8584)",
    fill: "#3086EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.251 70.5736C127.233 70.3699 127.384 70.1903 127.587 70.1725C127.791 70.1547 127.971 70.3054 127.988 70.5091C128.006 70.7128 127.856 70.8924 127.652 70.9102C127.448 70.928 127.269 70.7773 127.251 70.5736Z",
    fill: "#3086EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.063 70.0434C128.859 70.0612 128.708 70.2408 128.726 70.4445C128.744 70.6482 128.924 70.7989 129.127 70.7811C129.331 70.7633 129.482 70.5837 129.464 70.38C129.446 70.1763 129.266 70.0256 129.063 70.0434Z",
    fill: "#3086EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.202 70.3155C130.184 70.1118 130.334 69.9322 130.538 69.9143C130.742 69.8965 130.921 70.0472 130.939 70.2509C130.957 70.4546 130.806 70.6342 130.603 70.652C130.399 70.6699 130.219 70.5192 130.202 70.3155Z",
    fill: "#3086EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.716 71.6479C127.513 71.6657 127.362 71.8453 127.38 72.049C127.398 72.2527 127.577 72.4034 127.781 72.3856C127.985 72.3678 128.135 72.1882 128.118 71.9845C128.1 71.7808 127.92 71.6301 127.716 71.6479Z",
    fill: "#3086EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.509 73.5244C127.491 73.3207 127.642 73.1411 127.846 73.1233C128.049 73.1054 128.229 73.2561 128.247 73.4598C128.264 73.6636 128.114 73.8431 127.91 73.861C127.706 73.8788 127.527 73.7281 127.509 73.5244Z",
    fill: "#3086EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.192 71.5188C128.988 71.5366 128.837 71.7162 128.855 71.9199C128.873 72.1236 129.053 72.2743 129.256 72.2565C129.46 72.2387 129.611 72.0591 129.593 71.8554C129.575 71.6517 129.396 71.501 129.192 71.5188Z",
    fill: "#3086EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.984 73.3953C128.967 73.1916 129.117 73.012 129.321 72.9942C129.525 72.9764 129.704 73.1271 129.722 73.3308C129.74 73.5345 129.589 73.7141 129.385 73.7319C129.182 73.7497 129.002 73.599 128.984 73.3953Z",
    fill: "#3086EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.667 71.3897C130.464 71.4076 130.313 71.5871 130.331 71.7908C130.348 71.9946 130.528 72.1452 130.732 72.1274C130.935 72.1096 131.086 71.93 131.068 71.7263C131.051 71.5226 130.871 71.3719 130.667 71.3897Z",
    fill: "#3086EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.46 73.2662C130.442 73.0625 130.593 72.8829 130.796 72.8651C131 72.8473 131.18 72.998 131.197 73.2017C131.215 73.4054 131.065 73.585 130.861 73.6028C130.657 73.6206 130.478 73.4699 130.46 73.2662Z",
    fill: "#3086EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.057 68.3605C127.039 68.1568 127.19 67.9773 127.394 67.9594C127.597 67.9416 127.777 68.0923 127.795 68.296L127.859 69.0337C127.877 69.2374 127.727 69.417 127.523 69.4348C127.319 69.4526 127.14 69.3019 127.122 69.0982L127.057 68.3605Z",
    fill: "#3086EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.345 67.7013C130.141 67.7191 129.99 67.8987 130.008 68.1024L130.072 68.8401C130.09 69.0438 130.27 69.1945 130.474 69.1767C130.677 69.1588 130.828 68.9792 130.81 68.7755L130.746 68.0378C130.728 67.8341 130.548 67.6834 130.345 67.7013Z",
    fill: "#3086EE"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_3095_24513",
    x: 17.7563,
    y: -4.21848,
    width: 120.916,
    height: 92.2977,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.66458
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.66458
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.082353 0 0 0 0 0.101961 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3095_24513"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1.11076,
    dy: 1.11076
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.66615
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0823529 0 0 0 0 0.101961 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_3095_24513",
    result: "effect2_dropShadow_3095_24513"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_3095_24513",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dd_3095_24513",
    x: 29.7519,
    y: 6.27782,
    width: 11.775,
    height: 79.2537,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.180546
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.180546
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.00392157 0 0 0 0 0.14902 0 0 0 0 0.207843 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3095_24513"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.722184
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.722184
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.00392157 0 0 0 0 0.14902 0 0 0 0 0.207843 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_3095_24513",
    result: "effect2_dropShadow_3095_24513"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_3095_24513",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_3095_24513",
    x: 0.145927,
    y: 32.6176,
    width: 46.5543,
    height: 46.5546,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.66459
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.66459
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.082353 0 0 0 0 0.101961 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3095_24513"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3095_24513",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_3095_24513",
    x: 107.612,
    y: 17.6225,
    width: 52.0704,
    height: 52.0702,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.66459
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.66459
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.082353 0 0 0 0 0.101961 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3095_24513"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3095_24513",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_3095_24513",
    x: 105.947,
    y: 55.2749,
    width: 46.5546,
    height: 46.5543,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.66459
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.66459
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.082353 0 0 0 0 0.101961 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3095_24513"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3095_24513",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3095_24513",
    x1: 24.2584,
    y1: 39.2822,
    x2: 24.2584,
    y2: 57.6476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9C9C9",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAEBF0",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3095_24513",
    x1: 24.2584,
    y1: 39.2822,
    x2: 24.2584,
    y2: 57.6476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CACCD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B6C72",
    stopOpacity: 0.25
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3095_24513",
    x1: 131.316,
    y1: 29.6572,
    x2: 131.316,
    y2: 50.4061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9C9C9",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAEBF0",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3095_24513",
    x1: 131.316,
    y1: 29.6572,
    x2: 131.316,
    y2: 50.4061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CACCD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B6C72",
    stopOpacity: 0.25
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3095_24513",
    x1: 128.459,
    y1: 63.54,
    x2: 128.459,
    y2: 81.9054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9C9C9",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAEBF0",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3095_24513",
    x1: 128.459,
    y1: 63.54,
    x2: 128.459,
    y2: 81.9054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CACCD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B6C72",
    stopOpacity: 0.25
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3095_24513"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.1963,
    y: 7,
    width: 94.036,
    height: 60.9746,
    rx: 4.44306,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3095_24513"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5.4951,
    height: 5.5108,
    fill: "white",
    transform: "translate(32.8918 11.7207)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_3095_24513"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 85.1498,
    height: 60.9746,
    fill: "white",
    transform: "translate(40.0825 7)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_3095_24513"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.88611,
    height: 8.88611,
    fill: "white",
    transform: "translate(124.411 67.8486) rotate(-5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileWarning);
export default __webpack_public_path__ + "static/media/mobile_warning.17e03fbdfca0bb345010d043e0cd20ab.svg";
export { ForwardRef as ReactComponent };